import classNames from 'classnames';

export interface ColorListProps {
  colors: string[];
  selectedColor: string;
  onChange: (color: string) => void;
}

interface ColorBadgeProps {
  color: string;
  selected?: boolean;
  onClick?: (color?: string) => void;
}

export const Badge = ({
  color,
  selected = false,
  onClick,
}: ColorBadgeProps) => {
  return (
    <div
      aria-label={color}
      onClick={() => onClick?.(color)}
      style={{
        backgroundColor: selected ? 'inherit' : color,
      }}
      className={classNames(
        'flex items-center justify-center rounded-full w-[17px] h-[17px] border',
        {
          'border-ds-primary border': selected,
        }
      )}
    >
      {selected && (
        <div
          style={{
            backgroundColor: color,
          }}
          className="rounded-full  w-3 h-3  rounded-full selected"
        />
      )}
    </div>
  );
};
export const ColorList = ({
  colors,
  selectedColor,
  onChange,
}: ColorListProps) => {
  return (
    <div className="flex flex-wrap gap-2.5">
      {colors.map((color) => (
        <Badge
          key={color}
          color={color}
          selected={color === selectedColor}
          onClick={() => onChange(color)}
        />
      ))}
    </div>
  );
};
